package com.klantenstop.web.data.models.dto.requests.categories

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class InsertCategory(
    val name: String = "",
    @SerialName("alt_text")
    val altText: String? = null,
    val highlighted: Boolean = false,
    val description: String = ""
) {
    // With the insert, the altText is not mandatory, so should not be checked
    val isValid get() = name.isNotBlank()
}
